import type { GoodsData } from '@banhala/ui-kit';
import type { RankingGoodsItem } from 'shared/src/api';
import { convertRenderDataToGoodsData } from 'shared/src/utils/convertRenderDataToGoodsData';
import { isNotNil } from '../../../../../../../../shared/src/utils';

export type RankingGoodsCardItem = GoodsData & {
  item: RankingGoodsItem;
  display: { ranking: number | null };
  logging: RankingGoodsItem['logging'];
  render: RankingGoodsItem['render'];
};

export const convertRankingGoodsItemToGoodsData = (
  goods: RankingGoodsItem,
): RankingGoodsCardItem => {
  const renderableInput = {
    item: {
      sno: goods.sno,
      delivery_type: goods.delivery_type,
      hasAd: isNotNil(goods.ad),
    },
    render: goods.render,
  };

  return {
    ...convertRenderDataToGoodsData(renderableInput, {
      thumbnailOverrides: {
        ranking: goods.ranking,
      },
    }),
    item: goods,
    display: { ranking: goods.ranking },
    logging: goods.logging,
    render: goods.render,
  };
};
